// @flow
export const ACQUIRE_DEVICES = 'hive/devices/ACQUIRE_DEVICES';
export const CLOSE_PLACEMENT_ADVICE = 'hive/devices/CLOSE_PLACEMENT_ADVICE';
export const FINISH_INSTALL_DEVICES = 'hive/devices/FINISH_INSTALL_DEVICES';
export const FINISHED_INSTALL_DEVICES = 'hive/devices/FINISHED_INSTALL_DEVICES';
export const LOAD_INSTALL_DEVICES = 'hive/devices/LOAD_INSTALL_DEVICES';
export const START_ACQUIRE_DEVICES = 'hive/devices/START_ACQUIRE_DEVICES';
export const STOP_ACQUIRE_DEVICES = 'hive/devices/STOP_ACQUIRE_DEVICES';
export const UNLOAD_INSTALL_DEVICES = 'hive/devices/UNLOAD_INSTALL_DEVICES';
export const PLACEMENT_ADVICE_TYPES: { [string]: string } = {
    NOT_SHOWN: 'PLACEMENT_ADVICE_NOT_SHOWN',
    SHOW: 'PLACEMENT_ADVICE_SHOW',
    SHOWN: 'PLACEMENT_ADVICE_SHOWN'
};



// WEBPACK FOOTER //
// ./src/core/state/acquire-devices/constants.js